export default __webpack_public_path__ + "static/media/cal-diaphragm.c900f304.jpg";